<template>
  <component :is="logoObject[name]" />
</template>

<script lang="ts" setup>
import SecurePayment from '@/components/logo/_logos/secure-payment.vue';
import Regular from '@/components/logo/_logos/regular.vue';

import type { LogoProps } from '@/types';

const logoObject = {
  securePayment: SecurePayment,
  regular: Regular,
};

defineProps<LogoProps>();
</script>
